var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products-show-view"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isSuccessfullyLoaded) ? _c('div', [_c('div', {
    staticClass: "action-buttons-container"
  }, [_c('div', {
    staticClass: "action-buttons"
  }, [_c('link-button', {
    attrs: {
      "to": {
        name: 'edit-product',
        params: {
          id: _vm.product.id
        }
      },
      "icon": "pencil"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.edit')) + "\n        ")]), _vm._v(" "), _c('link-button', {
    attrs: {
      "to": {
        name: 'product-revisions',
        params: {
          id: _vm.product.id
        }
      },
      "icon": "future"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.editRevisions')) + "\n        ")]), _vm._v(" "), _c('common-button', {
    attrs: {
      "type": "danger",
      "icon": "trash"
    },
    on: {
      "click": _vm.deleteProductWhenConfirmed
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.delete')) + "\n        ")])], 1), _vm._v(" "), (_vm.hasActiveRevision) ? _c('div', {
    staticClass: "active-revision-indicator"
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  }), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.$t('hints.activeRevision')) + " ")])], 1) : _vm._e()]), _vm._v(" "), _c('mini-gallery', {
    attrs: {
      "record": _vm.product
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.attributes')))]), _vm._v(" "), _c('attribute-table', {
    attrs: {
      "data": _vm.product,
      "fields": _vm.tableFields
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(type) {
        return [(_vm.product.bundle) ? _c('span', [_vm._v(_vm._s(_vm.$t('types.bundle')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('types.standard')))])]
      }
    }, {
      key: "model",
      fn: function(model) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'product-family',
              params: {
                id: _vm.product.family.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.product.family.model) + "\n        ")])]
      }
    }, {
      key: "insertedAt",
      fn: function(insertedAt) {
        return [_c('timeago', {
          attrs: {
            "since": insertedAt.value,
            "auto-update": 60
          }
        })]
      }
    }, {
      key: "updatedAt",
      fn: function(updatedAt) {
        return [_c('timeago', {
          attrs: {
            "since": updatedAt.value,
            "auto-update": 60
          }
        })]
      }
    }, {
      key: "manufacturerProductCode",
      fn: function(manufacturerProductCode) {
        return [_c('timeago', {
          attrs: {
            "since": manufacturerProductCode.value,
            "auto-update": 60
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "family"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'product-family',
        params: {
          id: _vm.product.family.id
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.product.family.name) + "\n        ")])], 1), _vm._v(" "), (_vm.product.family.brand) ? _c('template', {
    slot: "brand"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-brand',
        params: {
          id: _vm.product.family.brand.id
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.product.family.brand.name) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "totalStock"
  }, [_c('router-link', {
    class: _vm.totalStockClass,
    attrs: {
      "to": {
        name: 'product-availabilities',
        id: _vm.product.id
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('unitsInStock', {
    count: _vm.totalStock
  })) + "\n        ")])], 1), _vm._v(" "), _c('template', {
    slot: "customizability"
  }, [_vm._v("\n        " + _vm._s(_vm.$t(("productCustomizabilities." + (_vm.product.customizability)))) + "\n      ")])], 2), _vm._v(" "), (_vm.product.bundle) ? [_c('h3', [_vm._v(_vm._s(_vm.$t('headlines.bundledProducts')))]), _vm._v(" "), (_vm.bundledProducts.length) ? _c('product-table', {
    attrs: {
      "products": _vm.bundledProducts
    }
  }) : _c('div', {
    staticClass: "uk-placeholder uk-text-center"
  }, [_c('icon', {
    staticClass: "uk-margin-small-right",
    attrs: {
      "name": "warning"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('hints.noBundledProducts')) + "\n      ")], 1)] : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.offers', {
    count: _vm.product.offers.length
  })))]), _vm._v(" "), _c('link-button', {
    attrs: {
      "to": {
        name: 'new-offer',
        query: {
          productId: _vm.id
        }
      },
      "type": "primary",
      "icon": "plus"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.add')) + "\n    ")]), _vm._v(" "), (_vm.product.offers.length) ? _c('product-offer-table', {
    attrs: {
      "offers": _vm.product.offers
    }
  }) : _c('div', {
    staticClass: "uk-placeholder uk-text-center"
  }, [_c('icon', {
    staticClass: "uk-margin-small-right",
    attrs: {
      "name": "warning"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('hints.noOffers')) + "\n    ")], 1)], 2) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-788526a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Products/ShowView.vue
// module id = 2067
// module chunks = 0